const enImpersonate = {
  impersonate: {
    action: 'Login as',
    confirmation: 'Are you sure to login as {name} ?',
    details: 'By clicking <b>Yes, login!</b>, you will perform login as:',
    details2: 'Use this with responsibility and be cautious on your actions.',
    perform: 'Yes, login!',
    revert: 'Go back to my original account',
    name: 'Name',
    email: 'Email',
  }
}

export default enImpersonate
